import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';

const PreFetch = ({ router, page }) => {
  useEffect(() => {
    router.prefetch(page);
  }, [page, router]);

  return null;
};

PreFetch.propTypes = {
  page: PropTypes.string.isRequired,
  router: PropTypes.shape({
    prefetch: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(PreFetch);
